import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { Booking } from './Booking.js';

/**
 * The booking that stands for one contract: the schools the contract has, for the time it runs. It is derived from the
 * contract and follows it - see `syncEmployeeBookings` - so it is never edited by hand.
 * @class EmployeeBooking
 * @extends Booking
 */
@Entity()
export class EmployeeBooking extends Booking {
  static override _class = 'EmployeeBooking';

  constructor(doc: PartialEntityData<EmployeeBooking>) {
    super(doc);
  }

  /** The contract this booking stands for. */
  @Field(() => ID)
  contractID: Maybe<string>;
}
